import React from 'react';
import { getSpotifyAuthUrl, checkScopeVersion } from './spotify';
import styles from './SpotifyGf.module.css';

const STEPS = [
  { num: '01', label: 'Connect Spotify' },
  { num: '02', label: 'Scan liked songs' },
  { num: '03', label: 'Identify genres' },
  { num: '04', label: 'Create playlists' },
];

const SpotifyGf = () => {
  return (
    <div className={styles.page}>

      {/* NAV */}
      <nav className={styles.nav}>
        <a href="/" className={styles.navLogo}>basith</a>
        <span className={styles.navTag}>i'm so bored</span>
      </nav>

      {/* HERO */}
      <section className={styles.hero}>
        <p className={styles.eyebrow}></p>
        <h1 className={styles.headline}>
          built the playlist app<br />
          <span className={styles.headlineAccent}> she never asked for</span>
        </h1>
        <p className={styles.subline}>
          you don't listen to music like i do.
        </p>
        <div className={styles.ctaRow}>
          <button
            type="button"
            className={styles.spotifyBtn}
            onClick={async () => { checkScopeVersion(); window.location.href = await getSpotifyAuthUrl(); }}
          >
            <span className={styles.spotifyDot} />
            connect with spotify
          </button>
          <span className={styles.ctaMeta}>free to use.</span>
        </div>
      </section>

      {/* DIVIDER */}
      <div className={styles.divider} />

      {/* WHAT IT DOES */}
      <section className={styles.section}>
        <p className={styles.sectionLabel}>what this actually does</p>
        <p className={styles.sectionBody}>
          scans everything you've ever liked. sorts it into real genres. not 40 micro-playlists
          with names like <em>"sad indie for rainy tuesdays."</em>
        </p>
        <div className={styles.pills}>
          <span className={styles.pill}>no subgenres</span>
          <span className={styles.pill}>no duplicates</span>
          <span className={styles.pill}>no algorithm nonsense</span>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className={styles.section}>
        <p className={styles.sectionLabel}>four steps, i promise</p>
        <div className={styles.steps}>
          {STEPS.map((step, i) => (
            <React.Fragment key={step.num}>
              <div className={styles.step}>
                <span className={styles.stepNum}>{step.num}</span>
                <span className={styles.stepLabel}>{step.label}</span>
              </div>
              {i < STEPS.length - 1 && <div className={styles.stepConnector} />}
            </React.Fragment>
          ))}
        </div>
      </section>

      {/* EMOTIONAL TWIST */}
      <section className={styles.twist}>
        <p className={styles.twistLine}>whoever you are, this was made for you.</p>
        <p className={styles.twistMeta}>(balls.)</p>
      </section>

      {/* FOOTER */}
      <footer className={styles.footer}>
        <div className={styles.footerTop}>
          <span>built by <a href="https://twitter.com/basithladoo" className={styles.footerLink}>basith</a></span>
          <span className={styles.footerRight}>we are all going to be worm food</span>
        </div>
        <div className={styles.footerCredit}>
          idea by <a href="https://twitter.com/twinksRUINme" target="_blank" rel="noopener noreferrer" className={styles.footerLink}>lallu eboy</a>
        </div>
        <div className={styles.footerLinks}>
          <a href="https://letterboxd.com/basithladoo/" target="_blank" rel="noopener noreferrer" className={styles.footerLink}>
            letterboxd
          </a>
          <a href="https://open.spotify.com/user/31kc2rvppa2sk2v63yrggc2lp7s4?si=c0e8772f810b43a4" target="_blank" rel="noopener noreferrer" className={styles.footerLink}>
            spotify
          </a>
        </div>
        <a href="mailto:basithladoo@gmail.com" className={styles.footerEmail}>
          basithladoo@gmail.com
        </a>
      </footer>

    </div>
  );
};

export default SpotifyGf;
